import { ApiErrorResponse } from "Data/interfaces";

export const getErrorMessage = (error: unknown): string => {
  const errorMessage = "An error occurred"; // Default fallback message

  if (
    typeof error === "object" &&
    error !== null &&
    "status" in error &&
    "data" in error &&
    typeof (error as ApiErrorResponse).data === "object" &&
    "message" in (error as ApiErrorResponse).data
  ) {
    return (error as ApiErrorResponse).data.message || errorMessage;
  }

  return errorMessage;
};
